import { Card, CardBody, Col, Row } from "reactstrap";
import { ProgressBar } from "../../../../AbstractElements";
import { SmallProgressTitle } from "../../../../Constants/Constants";
import { SmallProgressData, SmallProgressSubTitle } from "../../../../Data/UiKits/Progress";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SmallProgress = () => {
  return (
    <Card className="height-equal">
      <CommonCardHeader title={SmallProgressTitle} span={SmallProgressSubTitle} />
      <CardBody className="progress-showcase progress-b-space">
        <Row>
          <Col>
            {SmallProgressData &&
              SmallProgressData.map((item, index) => (
                <ProgressBar color="primary" animated striped bar value={item.value} className="small-progressbar rounded-pill sm-progress-bar overflow-visible mt-4" key={index}>
                  <span className="txt-primary progress-label">{item.text}</span>
                  <span className="animate-circle"></span>
                </ProgressBar>
              ))}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default SmallProgress;
